import classnames from "classnames";
import extractViewBoxParameters from "utils/extractViewBoxParameters";
import PropTypes from "prop-types";
import React from "react";
import isNumber from "lodash/isNumber";
import * as ImageSize from "utils/ImageSize";
import generateImageLink from "utils/generateImageLink";
import styles from "./MonogramIconStyles.css";

export default function MonogramIcon(props) {
  const extension = props.logoContent.split(".").pop().toLowerCase();
  const isImage =
    extension === "png" || extension === "jpg" || extension === "jpeg";

  let opacityCss = "";
  const opacity = isNumber(props.logoOpacity) ? props.logoOpacity : 0.9;
  const opacitySetting = Math.max(0.1, Math.min(0.9, opacity));
  const opacityHoverSetting = opacitySetting + 0.1; // 10% increase

  opacityCss = `
        .nav__monogram .nav__action-icon.${styles.root} {
            opacity: ${opacitySetting};
            transition: opacity 0.25s ease-out;
        }
        .nav__monogram:hover .nav__action-icon.${styles.root} {
            opacity: ${opacityHoverSetting};
        }
    `;

  if (isImage) {
    let rootStyle = {
      height: props.height,
    };

    if (isNumber(props.logoBorderRadiusPercent)) {
      rootStyle = {
        ...rootStyle,
        borderRadius: `${props.logoBorderRadiusPercent}%`,
        overflow: "hidden",
      };
    }

    return (
      <div className={`nav__action-icon ${styles.root}`} style={rootStyle}>
        <div
          className={classnames(styles.monogram, {
            [styles.transitionEffects]: props.transitionEffects,
          })}
        >
          <img
            alt=""
            src={generateImageLink(props.logoContent, {
              size: ImageSize.SMALL,
              format: "f_auto",
            })}
            style={{
              height: props.height,
            }}
          />
        </div>
        <style>{opacityCss}</style>
      </div>
    );
  }

  const isSvg = props.logoContent.indexOf("<svg") > -1;
  let aspectRatio = 1;
  let style = {};
  if (isSvg) {
    const viewbox = extractViewBoxParameters(props.logoContent);
    aspectRatio = viewbox.height / viewbox.width;
    style = {
      height: props.height,
      width: props.height / aspectRatio,
    };
  }

  return (
    <div className={`nav__action-icon ${styles.root}`} style={style}>
      <div
        className={classnames(styles.monogram, {
          [styles.transitionEffects]: props.transitionEffects,
        })}
        dangerouslySetInnerHTML={{ __html: props.logoContent }}
      />
      <style>{opacityCss}</style>
    </div>
  );
}

MonogramIcon.propTypes = {
  height: PropTypes.number.isRequired,
  logoBorderRadiusPercent: PropTypes.number,
  logoContent: PropTypes.string.isRequired,
  logoOpacity: PropTypes.number,
  transitionEffects: PropTypes.bool.isRequired,
};
